import FormGroup from "legacy/FormGroup"
import { handleInputChange, paymentMethodDisplayText } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: jQuery ($) is loaded globally

class ChangeReservationPaymentController extends React.Component {
  constructor(props) {
    super(props)

    const paymentType = this.initialPaymentType()

    this.state = {
      processing: false,
      selectedPaymentMethodId: this.initialPaymentMethodId(paymentType),
      paymentType,
      isManual:
        this.props.paymentType === "manual" ||
        this.props.paymentType === "cash",
      showModal: false,
    }

    this.validator = validatorFactory()
    this.handleInputChange = this.handleInputChange.bind(this)
    this.submit = this.submit.bind(this)
    this.postSubmit = this.postSubmit.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleUpdatePaymentType = this.handleUpdatePaymentType.bind(this)
    this.noUpdateMade = this.noUpdateMade.bind(this)
    this.handleFailure = this.handleFailure.bind(this)

    this.VARIANTS = {
      reservation: {
        button: "btn btn-secondary",
        buttonCell: "col-start-2",
        modal: {
          cancelBtnClass: "btn btn-secondary mr-3",
        },
      },
      contract: {
        button: "btn btn-tertiary",
        buttonCell: "flex col-start-3 justify-end",
        modal: {
          cancelBtnClass: "btn btn-tertiary mr-3",
        },
      },
    }
  }

  initialPaymentType() {
    if (this.noPaymentMethods()) {
      return "manual"
    } else if (
      this.props.paymentType === "unpaid" ||
      this.props.legacyPayments
    ) {
      return "credit"
    } else {
      return this.props.paymentType
    }
  }

  initialPaymentMethodId(paymentType) {
    let currentPaymentMethodIsActive = false

    if (this.props.currentPaymentMethod) {
      currentPaymentMethodIsActive = this.props.paymentMethodOptions.some(
        (paymentMethod) => {
          return (
            paymentMethod.stripePaymentMethodId ===
            this.props.currentPaymentMethod.stripePaymentMethodId
          )
        }
      )
    }

    if (paymentType === "credit" && currentPaymentMethodIsActive) {
      return this.props.currentPaymentMethod.stripePaymentMethodId
    } else if (paymentType === "credit") {
      return this.props.paymentMethodOptions[0].stripePaymentMethodId
    } else {
      return ""
    }
  }

  noPaymentMethods() {
    return this.props.paymentMethodOptions.length === 0
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({
      showModal: false,
      selectedPaymentMethodId: this.props.selectedPaymentMethodId,
    })
  }

  handleFailure(error) {
    this.setState({
      processing: false,
      error,
    })
  }

  postSubmit(cardToken = null) {
    const params = {
      _method: "patch",
      payment_type: this.state.paymentType,
    }

    params.card_id =
      this.state.paymentType === "credit"
        ? this.state.selectedPaymentMethodId
        : ""

    $.post(`${this.props.updateUrl}`, params, (data) => {
      window.location.reload(false)
    }).fail((data) => {
      let error = "Failed to save card."
      if (data.responseText && JSON.parse(data.responseText).error) {
        error = JSON.parse(data.responseText).error
      }
      this.handleFailure(error)
    })
  }

  submit() {
    if (this.validator.allValid()) {
      this.setState({ processing: true })

      this.postSubmit()
    } else {
      this.validator.showMessages()
      // rerender to show messages for the first time
      this.forceUpdate()
    }
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  handleUpdatePaymentType(event) {
    const paymentType = event.target.value
    const selectedPaymentMethodId =
      paymentType === "manual" ? "" : this.initialPaymentMethodId(paymentType)

    this.setState({
      paymentType,
      selectedPaymentMethodId,
    })
  }

  cardSelector() {
    if (
      (this.props.paymentMethodOptions &&
        this.state.paymentType === "credit") ||
      this.state.paymentType === "unpaid"
    ) {
      return (
        <FormGroup
          inputType="select"
          label="Select Payment Method"
          name="selectedPaymentMethodId"
          value={this.state.selectedPaymentMethodId}
          onChange={this.handleInputChange}
        >
          {_.map(this.props.paymentMethodOptions, (paymentMethod) => {
            return (
              <option
                key={paymentMethod.id}
                value={paymentMethod.stripePaymentMethodId}
              >
                {paymentMethodDisplayText(paymentMethod)}
              </option>
            )
          })}
        </FormGroup>
      )
    }
  }

  paymentTypeSelector() {
    return (
      <FormGroup
        inputType="select"
        label="Autopay"
        name="paymentType"
        value={this.state.paymentType}
        onChange={this.handleUpdatePaymentType}
      >
        <option value="credit" disabled={this.noPaymentMethods()}>
          Enabled
        </option>
        <option value="manual">Disabled (Settle Manually)</option>
      </FormGroup>
    )
  }

  modalLinkToEditContactCards() {
    return (
      <a
        href={`${this.props.contactPaymentUrl}#payment-methods`}
        className="plain-link"
      >
        {"Edit Contact's Payment Methods"}
      </a>
    )
  }

  renderCardText() {
    if (this.state.isManual) {
      return "Settle manually"
    } else if (this.props.currentPaymentMethod) {
      if (this.props.currentPaymentMethod.type === "PaymentMethod::Card") {
        return `${this.props.currentPaymentMethod.title} (${this.props.currentPaymentMethod.metadata.funding})`
      } else {
        return this.props.currentPaymentMethod.title
      }
    } else {
      return "No payment method selected"
    }
  }

  renderPaymentButton() {
    const { variant } = this.props
    const variantClasses = this.VARIANTS[variant]

    if (this.props.canEdit) {
      return (
        <button
          type="button"
          className={variantClasses.button}
          onClick={this.openModal}
        >
          Change
        </button>
      )
    }
  }

  modalContents() {
    const { variant } = this.props

    return (
      <div>
        {variant === "contract" && (
          <div className="mb-4">
            Update the payment method of all scheduled payments
          </div>
        )}
        {this.paymentTypeSelector()}
        {this.noPaymentMethods() && (
          <div className="text-status-red my-4 text-xs">
            This user has no payment methods. Please add a payment method to
            enable autopay.
          </div>
        )}
        {this.cardSelector()}
      </div>
    )
  }

  noUpdateMade() {
    return (
      this.props.currentPaymentMethod &&
      this.props.currentPaymentMethod.stripePaymentMethodId ===
        this.state.selectedPaymentMethodId &&
      this.props.paymentType === this.state.paymentType
    )
  }

  render() {
    const { variant } = this.props
    const variantClasses = this.VARIANTS[variant]

    this.validator.purgeFields()

    return (
      <div className="grid grid-cols-3">
        <div className="text-xs.md:text-sm flex items-center">
          {this.renderCardText()}
        </div>
        <div className={variantClasses.buttonCell}>
          {this.renderPaymentButton()}
        </div>
        {this.state.showModal && (
          <Modal isOpen={true} onClose={this.closeModal} size="mediumFixed">
            <Modal.Header title="Update Autopay" />
            <Modal.Body>{this.modalContents()}</Modal.Body>
            <Modal.Footer>
              <div className="flex w-full items-center justify-between">
                <div>{this.modalLinkToEditContactCards()}</div>
                <div className="flex gap-2">
                  <button
                    type="button"
                    className={
                      variant === "contract"
                        ? "btn btn-tertiary"
                        : "btn btn-secondary"
                    }
                    onClick={this.closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.submit}
                    disabled={this.noUpdateMade()}
                  >
                    {this.state.processing ? (
                      <>
                        <i
                          className="fa-kit fa-spinner fa-spin mr-1"
                          aria-hidden="true"
                        />
                        Saving...
                      </>
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    )
  }
}

ChangeReservationPaymentController.propTypes = {
  paymentType: PropTypes.string,
  legacyPayments: PropTypes.bool,
  currentPaymentMethod: PropTypes.shape({
    stripePaymentMethodId: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    metadata: PropTypes.shape({
      funding: PropTypes.string,
    }),
  }),
  paymentMethodOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      stripePaymentMethodId: PropTypes.string.isRequired,
    })
  ).isRequired,
  updateUrl: PropTypes.string.isRequired,
  contactPaymentUrl: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  variant: PropTypes.oneOf(["reservation", "contract"]),
  selectedPaymentMethodId: PropTypes.string,
}

ChangeReservationPaymentController.defaultProps = {
  variant: "reservation",
}

export default ChangeReservationPaymentController
